// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   ERP Modern Side Modal
   Matching System Theme (Purple / Indigo)
========================================================= */
:host ::ng-deep {
  /* =========================================================
     Modal Wrapper
  ========================================================= */
}
:host ::ng-deep .payment-history-side-modal {
  /* =========================================================
     Close when click outside
  ========================================================= */
  /* =========================================================
     RTL => LEFT
  ========================================================= */
  /* =========================================================
     LTR => RIGHT
  ========================================================= */
}
:host ::ng-deep .payment-history-side-modal .modal-dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  margin: 0 !important;
  width: 100%;
  max-width: 720px;
  height: 100vh;
  transition: transform 0.28s ease, opacity 0.28s ease;
  overflow: hidden;
}
:host ::ng-deep .payment-history-side-modal .modal-content {
  height: 100vh;
  border: none;
  border-radius: 0 !important;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff 0%, #fbfbff 100%);
  box-shadow: 0 0 0 1px rgba(84, 72, 255, 0.06), 0 20px 50px rgba(27, 31, 59, 0.18);
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
}
:host ::ng-deep .payment-history-side-modal .modal-backdrop.show {
  opacity: 0.45 !important;
  background: linear-gradient(180deg, rgba(19, 23, 41, 0.55), rgba(34, 39, 72, 0.45));
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
}
[dir=rtl] :host ::ng-deep .payment-history-side-modal .modal-dialog {
  left: 0;
  right: auto;
}
[dir=rtl] :host ::ng-deep .payment-history-side-modal.fade .modal-dialog {
  transform: translateX(-100%);
}
[dir=rtl] :host ::ng-deep .payment-history-side-modal.show .modal-dialog {
  transform: translateX(0);
}
[dir=ltr] :host ::ng-deep .payment-history-side-modal .modal-dialog {
  right: 0;
  left: auto;
}
[dir=ltr] :host ::ng-deep .payment-history-side-modal.fade .modal-dialog {
  transform: translateX(100%);
}
[dir=ltr] :host ::ng-deep .payment-history-side-modal.show .modal-dialog {
  transform: translateX(0);
}

/* =========================================================
   Main Modal
========================================================= */
.payment-history-modal {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff 0%, #fafaff 100%);
  color: #2d3557;
  /* =========================================================
     HEADER
  ========================================================= */
  /* =========================================================
     BODY
  ========================================================= */
  /* =========================================================
     SUMMARY SECTION
  ========================================================= */
  /* =========================================================
     TIMELINE SECTION
  ========================================================= */
  /* =========================================================
     FOOTER
  ========================================================= */
}
.payment-history-modal .modal-header {
  position: relative;
  padding: 1.1rem 1.35rem;
  border: none;
  background: linear-gradient(135deg, #3f37c9 0%, #4f46e5 45%, #5b52ff 100%);
  box-shadow: 0 2px 12px rgba(79, 70, 229, 0.18);
  flex-shrink: 0;
  /* =========================================================
     Premium Close Button
  ========================================================= */
}
.payment-history-modal .modal-header .modal-title {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin: 0;
  font-size: 1.05rem;
  font-weight: 800;
  color: #ffffff;
}
.payment-history-modal .modal-header .modal-title i {
  font-size: 1rem;
  color: #ffffff;
}
.payment-history-modal .modal-header .modal-title small {
  padding: 0.2rem 0.45rem;
  border-radius: 0.45rem;
  background: rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.7rem;
  font-weight: 600;
  font-family: monospace;
}
.payment-history-modal .modal-header .btn-close {
  position: relative;
  width: 42px;
  height: 42px;
  margin: 0;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0.08));
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  opacity: 1;
  transition: all 0.22s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08), 0 6px 18px rgba(0, 0, 0, 0.12);
  background-image: none !important;
}
.payment-history-modal .modal-header .btn-close::before {
  content: "\\f00d";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  color: #ffffff;
  font-size: 0.9rem;
}
.payment-history-modal .modal-header .btn-close:hover {
  transform: translateY(-2px) scale(1.04);
  background: linear-gradient(135deg, #ff4d6d, #ef476f);
  box-shadow: 0 10px 22px rgba(239, 71, 111, 0.35);
}
.payment-history-modal .modal-header .btn-close:active {
  transform: scale(0.96);
}
.payment-history-modal .modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 1.35rem;
  background: linear-gradient(180deg, #fbfbff 0%, #f7f8ff 100%);
}
.payment-history-modal .modal-body::-webkit-scrollbar {
  width: 9px;
}
.payment-history-modal .modal-body::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background: linear-gradient(180deg, #6c63ff, #4f46e5);
}
.payment-history-modal .modal-body::-webkit-scrollbar-track {
  background: transparent;
}
.payment-history-modal .payment-summary-section {
  margin-bottom: 1.8rem;
}
.payment-history-modal .payment-summary-section .summary-header {
  margin-bottom: 1rem;
}
.payment-history-modal .payment-summary-section .summary-header h6 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  font-size: 0.92rem;
  font-weight: 800;
  color: #3b3f5c;
}
.payment-history-modal .payment-summary-section .summary-header h6 i {
  color: #4f46e5;
}
.payment-history-modal .payment-summary-section .summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(165px, 1fr));
  gap: 1rem;
}
.payment-history-modal .payment-summary-section .summary-card {
  position: relative;
  overflow: hidden;
  padding: 1rem;
  border-radius: 1rem;
  background: linear-gradient(180deg, #ffffff, #fafaff);
  border: 1px solid rgba(79, 70, 229, 0.08);
  box-shadow: 0 10px 25px rgba(79, 70, 229, 0.05);
  transition: all 0.24s ease;
}
.payment-history-modal .payment-summary-section .summary-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 32px rgba(79, 70, 229, 0.12);
}
.payment-history-modal .payment-summary-section .summary-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #4f46e5, #6c63ff);
}
.payment-history-modal .payment-summary-section .summary-card .summary-label {
  color: #7a7fa1;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.4px;
}
.payment-history-modal .payment-summary-section .summary-card .summary-value {
  margin-top: 0.35rem;
  color: #2f365f;
  font-size: 1rem;
  font-weight: 800;
}
.payment-history-modal .payment-summary-section .summary-card .summary-value.text-success {
  color: #00a86b;
}
.payment-history-modal .payment-summary-section .summary-card .summary-value.text-warning {
  color: #f59e0b;
}
.payment-history-modal .payment-history-section {
  /* =========================================================
     Timeline
  ========================================================= */
}
.payment-history-modal .payment-history-section .timeline-header {
  margin-bottom: 1rem;
}
.payment-history-modal .payment-history-section .timeline-header h6 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  font-size: 0.92rem;
  font-weight: 800;
  color: #3b3f5c;
}
.payment-history-modal .payment-history-section .timeline-header h6 i {
  color: #4f46e5;
}
.payment-history-modal .payment-history-section .timeline-vertical {
  position: relative;
  padding-inline-start: 2rem;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-line {
  position: absolute;
  top: 10px;
  bottom: 10px;
  width: 4px;
  border-radius: 999px;
  background: linear-gradient(180deg, #8b84ff, #4f46e5, #8b84ff);
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.4rem;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-dot {
  width: 50px;
  height: 50px;
  border-radius: 18px;
  background: linear-gradient(135deg, #4f46e5, #6c63ff);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 12px 24px rgba(79, 70, 229, 0.22);
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-dot i {
  color: #ffffff;
  font-size: 1rem;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card {
  flex: 1;
  overflow: hidden;
  border-radius: 1rem;
  background: #ffffff;
  border: 1px solid rgba(79, 70, 229, 0.08);
  box-shadow: 0 10px 24px rgba(30, 41, 59, 0.05);
  transition: all 0.22s ease;
  /* =========================================================
     CARD HEADER
  ========================================================= */
  /* =========================================================
     CARD CONTENT
  ========================================================= */
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 18px 36px rgba(79, 70, 229, 0.12);
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 0.85rem 1rem;
  background: linear-gradient(180deg, #f9f9ff, #f4f5ff);
  border-bottom: 1px solid #ececff;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-header-section .header-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-header-section .payment-sequence {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.78rem;
  font-weight: 800;
  color: #373d68;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-header-section .payment-sequence i {
  color: #4f46e5;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-header-section .voucher-number {
  color: #6f76a1;
  font-size: 0.74rem;
  font-weight: 700;
  font-family: monospace;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-header-section .status-badge {
  padding: 0.32rem 0.75rem;
  border-radius: 999px;
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.3px;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-header-section .status-badge.status-paid {
  background: rgba(0, 168, 107, 0.12);
  color: #00a86b;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-header-section .status-badge.status-partial {
  background: rgba(245, 158, 11, 0.12);
  color: #d97706;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-header-section .status-badge.status-unpaid {
  background: rgba(239, 68, 68, 0.12);
  color: #dc2626;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-content {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-content .info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding-bottom: 0.65rem;
  border-bottom: 1px dashed #ececff;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-content .info-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-content .info-row .info-label {
  min-width: 120px;
  display: flex;
  align-items: center;
  gap: 0.45rem;
  color: #6d7397;
  font-size: 0.78rem;
  font-weight: 700;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-content .info-row .info-label i {
  color: #4f46e5;
  font-size: 0.72rem;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-content .info-row .info-value {
  flex: 1;
  font-size: 0.82rem;
  font-weight: 700;
  color: #31375f;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-content .info-row .info-value.amount-paid {
  color: #00a86b;
}
.payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-content .info-row .info-value.amount-remaining {
  color: #d97706;
}
.payment-history-modal .modal-footer {
  padding: 1rem 1.35rem;
  border: none;
  border-top: 1px solid #ececff;
  background: linear-gradient(180deg, #ffffff, #fafaff);
}
.payment-history-modal .modal-footer .btn {
  min-width: 130px;
  height: 44px;
  border-radius: 14px;
  font-weight: 700;
  transition: all 0.22s ease;
}
.payment-history-modal .modal-footer .btn-secondary {
  border: none;
  background: linear-gradient(135deg, #ef476f, #ff4d6d);
  color: #ffffff;
  box-shadow: 0 10px 20px rgba(239, 71, 111, 0.2);
}
.payment-history-modal .modal-footer .btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 28px rgba(239, 71, 111, 0.3);
}

/* =========================================================
   RTL
========================================================= */
[dir=rtl] .payment-history-modal {
  direction: rtl;
}
[dir=rtl] .payment-history-modal .modal-title,
[dir=rtl] .payment-history-modal .timeline-header h6 {
  flex-direction: row-reverse;
}
[dir=rtl] .payment-history-modal .timeline-vertical {
  padding-right: 2rem;
  padding-left: 0;
}
[dir=rtl] .payment-history-modal .timeline-vertical .timeline-line {
  right: 23px;
  left: auto;
}
[dir=rtl] .payment-history-modal .timeline-vertical .timeline-item {
  flex-direction: row-reverse;
}
[dir=rtl] .payment-history-modal .timeline-vertical .timeline-item .timeline-dot {
  order: 2;
}
[dir=rtl] .payment-history-modal .timeline-vertical .timeline-item .timeline-card {
  order: 1;
}
[dir=rtl] .payment-history-modal .timeline-vertical .timeline-item .card-content .info-row {
  flex-direction: row-reverse;
}
[dir=rtl] .payment-history-modal .timeline-vertical .timeline-item .card-content .info-row .info-value {
  text-align: left;
}

/* =========================================================
   LTR
========================================================= */
[dir=ltr] .payment-history-modal {
  direction: ltr;
}
[dir=ltr] .payment-history-modal .timeline-vertical {
  padding-left: 2rem;
  padding-right: 0;
}
[dir=ltr] .payment-history-modal .timeline-vertical .timeline-line {
  left: 23px;
  right: auto;
}
[dir=ltr] .payment-history-modal .timeline-vertical .timeline-item {
  flex-direction: row;
}

/* =========================================================
   RESPONSIVE
========================================================= */
@media (max-width: 768px) {
  :host ::ng-deep .payment-history-side-modal .modal-dialog {
    max-width: 100%;
  }
  .payment-history-modal .modal-body {
    padding: 1rem;
  }
  .payment-history-modal .payment-summary-section .summary-grid {
    grid-template-columns: 1fr;
  }
  .payment-history-modal .payment-history-section .timeline-vertical .timeline-item {
    gap: 0.75rem;
  }
  .payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-dot {
    width: 42px;
    height: 42px;
  }
  .payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-header-section {
    flex-direction: column;
    align-items: flex-start;
  }
  .payment-history-modal .payment-history-section .timeline-vertical .timeline-item .timeline-card .card-content .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/payment-history-modal/payment-history-modal.component.scss"],"names":[],"mappings":"AAAA;;;2DAAA;AAKA;EAEE;;6DAAA;AACF;AAGE;EAoCE;;6DAAA;EAaA;;6DAAA;EAoBA;;6DAAA;AA7DJ;AANI;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EAEA,oDACE;EAGF,gBAAA;AAIN;AADI;EACE,aAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EAEA,6DACE;EAIF,iFACE;EAGF,kCAAA;UAAA,0BAAA;AALN;AAYI;EACE,wBAAA;EACA,mFACE;EAGF,kCAAA;UAAA,0BAAA;AAbN;AAsBM;EACE,OAAA;EACA,WAAA;AApBR;AAuBM;EACE,4BAAA;AArBR;AAwBM;EACE,wBAAA;AAtBR;AAgCM;EACE,QAAA;EACA,UAAA;AA9BR;AAiCM;EACE,2BAAA;AA/BR;AAkCM;EACE,wBAAA;AAhCR;;AAsCA;;2DAAA;AAIA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EAEA,6DACE;EAIF,cAAA;EAEA;;6DAAA;EAsHA;;6DAAA;EAkCA;;6DAAA;EA2GA;;6DAAA;EA6PA;;6DAAA;AA5hBF;AAgCE;EACE,kBAAA;EAEA,uBAAA;EAEA,YAAA;EAEA,0EACE;EAKF,8CACE;EAEF,cAAA;EAmCA;;6DAAA;AAxEJ;AAuCI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EAEA,SAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,cAAA;AAxCN;AA0CM;EACE,eAAA;EACA,cAAA;AAxCR;AA2CM;EACE,uBAAA;EAEA,sBAAA;EAEA,qCAAA;EAEA,+BAAA;EAEA,iBAAA;EACA,gBAAA;EAEA,sBAAA;AA9CR;AAsDI;EACE,kBAAA;EAEA,WAAA;EACA,YAAA;EAEA,SAAA;EAEA,YAAA;EACA,mBAAA;EAEA,yFACE;EAIF,kCAAA;UAAA,0BAAA;EAEA,UAAA;EAEA,0BAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,qFACE;EAYF,iCAAA;AA5EN;AAmEM;EACE,gBAAA;EACA,kCAAA;EACA,gBAAA;EAEA,cAAA;EACA,iBAAA;AAlER;AAwEI;EACE,uCAAA;EAEA,qDACE;EAIF,gDACE;AA5ER;AA+EI;EACE,sBAAA;AA7EN;AAqFE;EACE,OAAA;EAEA,gBAAA;EAEA,gBAAA;EAEA,6DACE;AAvFN;AA2FI;EACE,UAAA;AAzFN;AA4FI;EACE,mBAAA;EAEA,qDACE;AA5FR;AAiGI;EACE,uBAAA;AA/FN;AAuGE;EACE,qBAAA;AArGJ;AAuGI;EACE,mBAAA;AArGN;AAuGM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EAEA,SAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,cAAA;AAxGR;AA0GQ;EACE,cAAA;AAxGV;AA6GI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AA3GN;AA8GI;EACE,kBAAA;EAEA,gBAAA;EAEA,aAAA;EAEA,mBAAA;EAEA,qDACE;EAIF,yCAAA;EAEA,+CACE;EAEF,0BAAA;AAvHN;AAyHM;EACE,2BAAA;EAEA,+CACE;AAzHV;AA4HM;EACE,WAAA;EAEA,kBAAA;EAEA,MAAA;EACA,OAAA;EACA,QAAA;EAEA,WAAA;EAEA,oDACE;AA/HV;AAoIM;EACE,cAAA;EAEA,iBAAA;EACA,gBAAA;EAEA,qBAAA;AApIR;AAuIM;EACE,mBAAA;EAEA,cAAA;EAEA,eAAA;EACA,gBAAA;AAvIR;AAyIQ;EACE,cAAA;AAvIV;AA0IQ;EACE,cAAA;AAxIV;AAkJE;EAuBE;;6DAAA;AApKJ;AA+II;EACE,mBAAA;AA7IN;AA+IM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EAEA,SAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,cAAA;AAhJR;AAkJQ;EACE,cAAA;AAhJV;AAyJI;EACE,kBAAA;EAEA,0BAAA;AAxJN;AA0JM;EACE,kBAAA;EAEA,SAAA;EACA,YAAA;EAEA,UAAA;EAEA,oBAAA;EAEA,8DACE;AA7JV;AAmKM;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EAEA,qBAAA;AAlKR;AAoKQ;EACE,WAAA;EACA,YAAA;EAEA,mBAAA;EAEA,qDACE;EAIF,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,cAAA;EAEA,+CACE;AA3KZ;AA6KU;EACE,cAAA;EACA,eAAA;AA3KZ;AA+KQ;EACE,OAAA;EAEA,gBAAA;EAEA,mBAAA;EAEA,mBAAA;EAEA,yCAAA;EAEA,8CACE;EAEF,0BAAA;EASA;;6DAAA;EA6EA;;6DAAA;AApQV;AAgLU;EACE,2BAAA;EAEA,+CACE;AAhLd;AAuLU;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EAEA,qBAAA;EAEA,qDACE;EAIF,gCAAA;AA3LZ;AA6LY;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AA3Ld;AA8LY;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,cAAA;AA9Ld;AAgMc;EACE,cAAA;AA9LhB;AAkMY;EACE,cAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,sBAAA;AAlMd;AAqMY;EACE,wBAAA;EAEA,oBAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,qBAAA;AAtMd;AAwMc;EACE,mCAAA;EACA,cAAA;AAtMhB;AAyMc;EACE,oCAAA;EACA,cAAA;AAvMhB;AA0Mc;EACE,mCAAA;EACA,cAAA;AAxMhB;AAiNU;EACE,aAAA;EAEA,aAAA;EACA,sBAAA;EACA,YAAA;AAhNZ;AAkNY;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EAEA,uBAAA;EAEA,iCAAA;AAlNd;AAoNc;EACE,mBAAA;EACA,iBAAA;AAlNhB;AAqNc;EACE,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,YAAA;EAEA,cAAA;EAEA,kBAAA;EACA,gBAAA;AAtNhB;AAwNgB;EACE,cAAA;EACA,kBAAA;AAtNlB;AA0Nc;EACE,OAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,cAAA;AA1NhB;AA4NgB;EACE,cAAA;AA1NlB;AA6NgB;EACE,cAAA;AA3NlB;AAyOE;EACE,qBAAA;EAEA,YAAA;EACA,6BAAA;EAEA,qDACE;AA1ON;AA8OI;EACE,gBAAA;EACA,YAAA;EAEA,mBAAA;EAEA,gBAAA;EAEA,0BAAA;AA/ON;AAkPI;EACE,YAAA;EAEA,qDACE;EAIF,cAAA;EAEA,+CACE;AAvPR;AAyPM;EACE,2BAAA;EAEA,+CACE;AAzPV;;AA+PA;;2DAAA;AAME;EACE,cAAA;AA/PJ;AAiQI;;EAEE,2BAAA;AA/PN;AAkQI;EACE,mBAAA;EACA,eAAA;AAhQN;AAkQM;EACE,WAAA;EACA,UAAA;AAhQR;AAmQM;EACE,2BAAA;AAjQR;AAmQQ;EACE,QAAA;AAjQV;AAoQQ;EACE,QAAA;AAlQV;AAuQU;EACE,2BAAA;AArQZ;AAuQY;EACE,gBAAA;AArQd;;AA8QA;;2DAAA;AAME;EACE,cAAA;AA9QJ;AAgRI;EACE,kBAAA;EACA,gBAAA;AA9QN;AAgRM;EACE,UAAA;EACA,WAAA;AA9QR;AAiRM;EACE,mBAAA;AA/QR;;AAqRA;;2DAAA;AAIA;EAMM;IACE,eAAA;EAxRN;EA+RE;IACE,aAAA;EA7RJ;EAkSI;IACE,0BAAA;EAhSN;EAwSM;IACE,YAAA;EAtSR;EAwSQ;IACE,WAAA;IACA,YAAA;EAtSV;EA2SU;IACE,sBAAA;IACA,uBAAA;EAzSZ;EA8SY;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;EA5Sd;AACF","sourcesContent":["/* =========================================================\n   ERP Modern Side Modal\n   Matching System Theme (Purple / Indigo)\n========================================================= */\n\n:host ::ng-deep {\n\n  /* =========================================================\n     Modal Wrapper\n  ========================================================= */\n\n  .payment-history-side-modal {\n\n    .modal-dialog {\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      margin: 0 !important;\n      width: 100%;\n      max-width: 720px;\n      height: 100vh;\n\n      transition:\n        transform 0.28s ease,\n        opacity 0.28s ease;\n\n      overflow: hidden;\n    }\n\n    .modal-content {\n      height: 100vh;\n      border: none;\n      border-radius: 0 !important;\n      overflow: hidden;\n\n      background:\n        linear-gradient(180deg,\n          #ffffff 0%,\n          #fbfbff 100%);\n\n      box-shadow:\n        0 0 0 1px rgba(84, 72, 255, 0.06),\n        0 20px 50px rgba(27, 31, 59, 0.18);\n\n      backdrop-filter: blur(6px);\n    }\n\n    /* =========================================================\n       Close when click outside\n    ========================================================= */\n\n    .modal-backdrop.show {\n      opacity: 0.45 !important;\n      background:\n        linear-gradient(180deg,\n          rgba(19, 23, 41, 0.55),\n          rgba(34, 39, 72, 0.45));\n      backdrop-filter: blur(2px);\n    }\n\n    /* =========================================================\n       RTL => LEFT\n    ========================================================= */\n\n    [dir='rtl'] & {\n\n      .modal-dialog {\n        left: 0;\n        right: auto;\n      }\n\n      &.fade .modal-dialog {\n        transform: translateX(-100%);\n      }\n\n      &.show .modal-dialog {\n        transform: translateX(0);\n      }\n    }\n\n    /* =========================================================\n       LTR => RIGHT\n    ========================================================= */\n\n    [dir='ltr'] & {\n\n      .modal-dialog {\n        right: 0;\n        left: auto;\n      }\n\n      &.fade .modal-dialog {\n        transform: translateX(100%);\n      }\n\n      &.show .modal-dialog {\n        transform: translateX(0);\n      }\n    }\n  }\n}\n\n/* =========================================================\n   Main Modal\n========================================================= */\n\n.payment-history-modal {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n\n  background:\n    linear-gradient(180deg,\n      #ffffff 0%,\n      #fafaff 100%);\n\n  color: #2d3557;\n\n  /* =========================================================\n     HEADER\n  ========================================================= */\n\n  .modal-header {\n    position: relative;\n\n    padding: 1.1rem 1.35rem;\n\n    border: none;\n\n    background:\n      linear-gradient(135deg,\n        #3f37c9 0%,\n        #4f46e5 45%,\n        #5b52ff 100%);\n\n    box-shadow:\n      0 2px 12px rgba(79, 70, 229, 0.18);\n\n    flex-shrink: 0;\n\n    .modal-title {\n      display: flex;\n      align-items: center;\n      gap: 0.65rem;\n\n      margin: 0;\n\n      font-size: 1.05rem;\n      font-weight: 800;\n\n      color: #ffffff;\n\n      i {\n        font-size: 1rem;\n        color: #ffffff;\n      }\n\n      small {\n        padding: 0.2rem 0.45rem;\n\n        border-radius: 0.45rem;\n\n        background: rgba(255, 255, 255, 0.14);\n\n        color: rgba(255, 255, 255, 0.9);\n\n        font-size: 0.7rem;\n        font-weight: 600;\n\n        font-family: monospace;\n      }\n    }\n\n    /* =========================================================\n       Premium Close Button\n    ========================================================= */\n\n    .btn-close {\n      position: relative;\n\n      width: 42px;\n      height: 42px;\n\n      margin: 0;\n\n      border: none;\n      border-radius: 14px;\n\n      background:\n        linear-gradient(135deg,\n          rgba(255, 255, 255, 0.16),\n          rgba(255, 255, 255, 0.08));\n\n      backdrop-filter: blur(8px);\n\n      opacity: 1;\n\n      transition: all 0.22s ease;\n\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      box-shadow:\n        inset 0 0 0 1px rgba(255, 255, 255, 0.08),\n        0 6px 18px rgba(0, 0, 0, 0.12);\n\n      &::before {\n        content: '\\f00d';\n        font-family: 'Font Awesome 5 Free';\n        font-weight: 900;\n\n        color: #ffffff;\n        font-size: 0.9rem;\n      }\n\n      background-image: none !important;\n    }\n\n    .btn-close:hover {\n      transform: translateY(-2px) scale(1.04);\n\n      background:\n        linear-gradient(135deg,\n          #ff4d6d,\n          #ef476f);\n\n      box-shadow:\n        0 10px 22px rgba(239, 71, 111, 0.35);\n    }\n\n    .btn-close:active {\n      transform: scale(0.96);\n    }\n  }\n\n  /* =========================================================\n     BODY\n  ========================================================= */\n\n  .modal-body {\n    flex: 1;\n\n    overflow-y: auto;\n\n    padding: 1.35rem;\n\n    background:\n      linear-gradient(180deg,\n        #fbfbff 0%,\n        #f7f8ff 100%);\n\n    &::-webkit-scrollbar {\n      width: 9px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      border-radius: 20px;\n\n      background:\n        linear-gradient(180deg,\n          #6c63ff,\n          #4f46e5);\n    }\n\n    &::-webkit-scrollbar-track {\n      background: transparent;\n    }\n  }\n\n  /* =========================================================\n     SUMMARY SECTION\n  ========================================================= */\n\n  .payment-summary-section {\n    margin-bottom: 1.8rem;\n\n    .summary-header {\n      margin-bottom: 1rem;\n\n      h6 {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n\n        margin: 0;\n\n        font-size: 0.92rem;\n        font-weight: 800;\n\n        color: #3b3f5c;\n\n        i {\n          color: #4f46e5;\n        }\n      }\n    }\n\n    .summary-grid {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(165px, 1fr));\n      gap: 1rem;\n    }\n\n    .summary-card {\n      position: relative;\n\n      overflow: hidden;\n\n      padding: 1rem;\n\n      border-radius: 1rem;\n\n      background:\n        linear-gradient(180deg,\n          #ffffff,\n          #fafaff);\n\n      border: 1px solid rgba(79, 70, 229, 0.08);\n\n      box-shadow:\n        0 10px 25px rgba(79, 70, 229, 0.05);\n\n      transition: all 0.24s ease;\n\n      &:hover {\n        transform: translateY(-3px);\n\n        box-shadow:\n          0 16px 32px rgba(79, 70, 229, 0.12);\n      }\n\n      &::before {\n        content: '';\n\n        position: absolute;\n\n        top: 0;\n        left: 0;\n        right: 0;\n\n        height: 4px;\n\n        background:\n          linear-gradient(90deg,\n            #4f46e5,\n            #6c63ff);\n      }\n\n      .summary-label {\n        color: #7a7fa1;\n\n        font-size: 0.7rem;\n        font-weight: 700;\n\n        letter-spacing: 0.4px;\n      }\n\n      .summary-value {\n        margin-top: 0.35rem;\n\n        color: #2f365f;\n\n        font-size: 1rem;\n        font-weight: 800;\n\n        &.text-success {\n          color: #00a86b;\n        }\n\n        &.text-warning {\n          color: #f59e0b;\n        }\n      }\n    }\n  }\n\n  /* =========================================================\n     TIMELINE SECTION\n  ========================================================= */\n\n  .payment-history-section {\n\n    .timeline-header {\n      margin-bottom: 1rem;\n\n      h6 {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n\n        margin: 0;\n\n        font-size: 0.92rem;\n        font-weight: 800;\n\n        color: #3b3f5c;\n\n        i {\n          color: #4f46e5;\n        }\n      }\n    }\n\n    /* =========================================================\n       Timeline\n    ========================================================= */\n\n    .timeline-vertical {\n      position: relative;\n\n      padding-inline-start: 2rem;\n\n      .timeline-line {\n        position: absolute;\n\n        top: 10px;\n        bottom: 10px;\n\n        width: 4px;\n\n        border-radius: 999px;\n\n        background:\n          linear-gradient(180deg,\n            #8b84ff,\n            #4f46e5,\n            #8b84ff);\n      }\n\n      .timeline-item {\n        display: flex;\n        align-items: flex-start;\n        gap: 1rem;\n\n        margin-bottom: 1.4rem;\n\n        .timeline-dot {\n          width: 50px;\n          height: 50px;\n\n          border-radius: 18px;\n\n          background:\n            linear-gradient(135deg,\n              #4f46e5,\n              #6c63ff);\n\n          display: flex;\n          align-items: center;\n          justify-content: center;\n\n          flex-shrink: 0;\n\n          box-shadow:\n            0 12px 24px rgba(79, 70, 229, 0.22);\n\n          i {\n            color: #ffffff;\n            font-size: 1rem;\n          }\n        }\n\n        .timeline-card {\n          flex: 1;\n\n          overflow: hidden;\n\n          border-radius: 1rem;\n\n          background: #ffffff;\n\n          border: 1px solid rgba(79, 70, 229, 0.08);\n\n          box-shadow:\n            0 10px 24px rgba(30, 41, 59, 0.05);\n\n          transition: all 0.22s ease;\n\n          &:hover {\n            transform: translateY(-2px);\n\n            box-shadow:\n              0 18px 36px rgba(79, 70, 229, 0.12);\n          }\n\n          /* =========================================================\n             CARD HEADER\n          ========================================================= */\n\n          .card-header-section {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            gap: 1rem;\n\n            padding: 0.85rem 1rem;\n\n            background:\n              linear-gradient(180deg,\n                #f9f9ff,\n                #f4f5ff);\n\n            border-bottom: 1px solid #ececff;\n\n            .header-left {\n              display: flex;\n              align-items: center;\n              gap: 0.5rem;\n              flex-wrap: wrap;\n            }\n\n            .payment-sequence {\n              display: flex;\n              align-items: center;\n              gap: 0.35rem;\n\n              font-size: 0.78rem;\n              font-weight: 800;\n\n              color: #373d68;\n\n              i {\n                color: #4f46e5;\n              }\n            }\n\n            .voucher-number {\n              color: #6f76a1;\n\n              font-size: 0.74rem;\n              font-weight: 700;\n\n              font-family: monospace;\n            }\n\n            .status-badge {\n              padding: 0.32rem 0.75rem;\n\n              border-radius: 999px;\n\n              font-size: 0.65rem;\n              font-weight: 800;\n\n              letter-spacing: 0.3px;\n\n              &.status-paid {\n                background: rgba(0, 168, 107, 0.12);\n                color: #00a86b;\n              }\n\n              &.status-partial {\n                background: rgba(245, 158, 11, 0.12);\n                color: #d97706;\n              }\n\n              &.status-unpaid {\n                background: rgba(239, 68, 68, 0.12);\n                color: #dc2626;\n              }\n            }\n          }\n\n          /* =========================================================\n             CARD CONTENT\n          ========================================================= */\n\n          .card-content {\n            padding: 1rem;\n\n            display: flex;\n            flex-direction: column;\n            gap: 0.75rem;\n\n            .info-row {\n              display: flex;\n              justify-content: space-between;\n              align-items: center;\n              gap: 1rem;\n\n              padding-bottom: 0.65rem;\n\n              border-bottom: 1px dashed #ececff;\n\n              &:last-child {\n                border-bottom: none;\n                padding-bottom: 0;\n              }\n\n              .info-label {\n                min-width: 120px;\n\n                display: flex;\n                align-items: center;\n                gap: 0.45rem;\n\n                color: #6d7397;\n\n                font-size: 0.78rem;\n                font-weight: 700;\n\n                i {\n                  color: #4f46e5;\n                  font-size: 0.72rem;\n                }\n              }\n\n              .info-value {\n                flex: 1;\n\n                font-size: 0.82rem;\n                font-weight: 700;\n\n                color: #31375f;\n\n                &.amount-paid {\n                  color: #00a86b;\n                }\n\n                &.amount-remaining {\n                  color: #d97706;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  /* =========================================================\n     FOOTER\n  ========================================================= */\n\n  .modal-footer {\n    padding: 1rem 1.35rem;\n\n    border: none;\n    border-top: 1px solid #ececff;\n\n    background:\n      linear-gradient(180deg,\n        #ffffff,\n        #fafaff);\n\n    .btn {\n      min-width: 130px;\n      height: 44px;\n\n      border-radius: 14px;\n\n      font-weight: 700;\n\n      transition: all 0.22s ease;\n    }\n\n    .btn-secondary {\n      border: none;\n\n      background:\n        linear-gradient(135deg,\n          #ef476f,\n          #ff4d6d);\n\n      color: #ffffff;\n\n      box-shadow:\n        0 10px 20px rgba(239, 71, 111, 0.2);\n\n      &:hover {\n        transform: translateY(-2px);\n\n        box-shadow:\n          0 14px 28px rgba(239, 71, 111, 0.3);\n      }\n    }\n  }\n}\n\n/* =========================================================\n   RTL\n========================================================= */\n\n[dir='rtl'] {\n\n  .payment-history-modal {\n    direction: rtl;\n\n    .modal-title,\n    .timeline-header h6 {\n      flex-direction: row-reverse;\n    }\n\n    .timeline-vertical {\n      padding-right: 2rem;\n      padding-left: 0;\n\n      .timeline-line {\n        right: 23px;\n        left: auto;\n      }\n\n      .timeline-item {\n        flex-direction: row-reverse;\n\n        .timeline-dot {\n          order: 2;\n        }\n\n        .timeline-card {\n          order: 1;\n        }\n\n        .card-content {\n\n          .info-row {\n            flex-direction: row-reverse;\n\n            .info-value {\n              text-align: left;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n/* =========================================================\n   LTR\n========================================================= */\n\n[dir='ltr'] {\n\n  .payment-history-modal {\n    direction: ltr;\n\n    .timeline-vertical {\n      padding-left: 2rem;\n      padding-right: 0;\n\n      .timeline-line {\n        left: 23px;\n        right: auto;\n      }\n\n      .timeline-item {\n        flex-direction: row;\n      }\n    }\n  }\n}\n\n/* =========================================================\n   RESPONSIVE\n========================================================= */\n\n@media (max-width: 768px) {\n\n  :host ::ng-deep {\n\n    .payment-history-side-modal {\n\n      .modal-dialog {\n        max-width: 100%;\n      }\n    }\n  }\n\n  .payment-history-modal {\n\n    .modal-body {\n      padding: 1rem;\n    }\n\n    .payment-summary-section {\n\n      .summary-grid {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    .payment-history-section {\n\n      .timeline-vertical {\n\n        .timeline-item {\n          gap: 0.75rem;\n\n          .timeline-dot {\n            width: 42px;\n            height: 42px;\n          }\n\n          .timeline-card {\n\n            .card-header-section {\n              flex-direction: column;\n              align-items: flex-start;\n            }\n\n            .card-content {\n\n              .info-row {\n                flex-direction: column;\n                align-items: flex-start;\n                gap: 0.3rem;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
